var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWsLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m35.84,0l-13.85,0.04l-11.52,19.97l6.89,11.99l18.48,-32z",
    fill: "#960145",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.2,0l-13.85,0.04l-11.52,19.97l6.89,11.99l18.48,-32z",
    fill: "#960145",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.47,0l-18.47,0l8.74,16.02l9.73,-16.02z",
    fill: "#960145",
    id: "svg_3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsLogoSmall);
export default __webpack_public_path__ + "static/media/ws-logo-small.b71277e5ad9f3d482db00d8c42e6eddf.svg";
export { ForwardRef as ReactComponent };